export const Side_Menu_Toggle_Status = "Side_Menu_Toggle_Status";
export const Side_Menu_Reset_Status = "Side_Menu_Reset_Status";